import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  footer_description:
    "An independent Christian community school serving families in West Alabama. Partnering with families to cultivate students who love the Lord, think biblically, and serve faithfully.",
  footer_est_line: "Est. 2026 · Meeting at Alta Independent Baptist Church, Berry, AL",
  footer_verse: "Train up a child in the way he should go",
  footer_verse_ref: "— Proverbs 22:6",
  contact_email: "zca.k.12.26@outlook.com",
  contact_phone: "(205) 200-6257",
  contact_address_line1: "20670 Jimmy Lunceford Rd",
  contact_address_line2: "Northport, AL 35475",
  dev_credit_text: "Powered by acsvirtualchurch.com",
  dev_credit_url: "https://acsvirtualchurch.com",
};

export default function SiteFooter() {
  const [s, setS] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/settings")
      .then((r) => setS({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);
  const phoneHref = "tel:" + (s.contact_phone || "").replace(/[^\d+]/g, "");

  return (
    <footer data-testid="site-footer" className="bg-purple-dark text-white/85 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/zca-logo.png" alt="ZCA" className="h-12 w-12 object-contain bg-white/95 rounded-sm p-1" />
            <div className="h-serif text-xl text-gold-light">Zion Christian Academy</div>
          </div>
          <p className="text-sm leading-relaxed max-w-md" data-testid="footer-description">
            {s.footer_description}
          </p>
          <div className="mt-6 text-xs tracking-[0.2em] uppercase text-gold-light font-bold" data-testid="footer-est-line">
            {s.footer_est_line}
          </div>
        </div>

        <div>
          <div className="h-serif text-gold text-sm mb-4 tracking-wide">Contact</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href={`mailto:${s.contact_email}`} className="hover:text-gold-light transition-colors" data-testid="footer-email">
                {s.contact_email}
              </a>
            </li>
            <li>
              <a href={phoneHref} className="hover:text-gold-light transition-colors" data-testid="footer-phone">
                {s.contact_phone}
              </a>
            </li>
            <li className="text-xs text-white/70 pt-2" data-testid="footer-address">
              {s.contact_address_line1}<br />
              {s.contact_address_line2}
            </li>
          </ul>
        </div>

        <div>
          <div className="h-serif text-gold text-sm mb-4 tracking-wide">Quick Links</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#how-it-works" className="hover:text-gold-light transition-colors">How Enrollment Works</a></li>
            <li><a href="/#tuition" className="hover:text-gold-light transition-colors">Tuition &amp; Payment</a></li>
            <li><a href="/#faq" className="hover:text-gold-light transition-colors">Frequently Asked Questions</a></li>
            <li><a href="/enroll" className="hover:text-gold-light transition-colors" data-testid="footer-enroll">Begin Enrollment</a></li>
            <li><a href="/api/handbook" target="_blank" rel="noreferrer" className="hover:text-gold-light transition-colors" data-testid="footer-handbook">Family Handbook (PDF)</a></li>
            <li><a href="/portal/login" className="hover:text-gold-light transition-colors" data-testid="footer-portal">Parent Portal</a></li>
            <li><a href="/superintendents" className="hover:text-gold-light transition-colors" data-testid="footer-superintendents">County BOE Directory</a></li>
            <li><a href="/records-request" className="hover:text-gold-light transition-colors" data-testid="footer-records">Records Request</a></li>
            <li><a href="/enrollment-policy" className="hover:text-gold-light transition-colors" data-testid="footer-enrollment-policy">Enrollment Policy</a></li>
            <li><a href="/refund-policy" className="hover:text-gold-light transition-colors" data-testid="footer-refund-policy">Refund Policy</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Zion Christian Academy. All rights reserved.</div>
          <div className="italic" data-testid="footer-verse">
            &ldquo;{s.footer_verse}&rdquo; {s.footer_verse_ref}
          </div>
        </div>
        {s.dev_credit_text && (
          <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-6 -mt-2 text-center sm:text-right text-[11px] text-white/45">
            {s.dev_credit_url ? (
              <a
                href={s.dev_credit_url}
                target="_blank"
                rel="noreferrer"
                className="hover:text-gold-light transition-colors"
                data-testid="footer-dev-credit"
              >
                {s.dev_credit_text}
              </a>
            ) : (
              <span data-testid="footer-dev-credit">{s.dev_credit_text}</span>
            )}
          </div>
        )}
      </div>
    </footer>
  );
}
